module.exports = __webpack_public_path__ + "static/media/WEBnegro_44.e186fec4.jpg";